// extracted by mini-css-extract-plugin
export var active = "GlobalSearch-module--active--fdd1f";
export var cdsAssistiveText = "GlobalSearch-module--cds--assistive-text--bc6c4";
export var cdsHideFeedback = "GlobalSearch-module--cds--hide-feedback--d2208";
export var cdsShowFeedback = "GlobalSearch-module--cds--show-feedback--cb494";
export var cdsSkeleton = "GlobalSearch-module--cds--skeleton--2aec2";
export var cdsVisuallyHidden = "GlobalSearch-module--cds--visually-hidden--130ca";
export var container = "GlobalSearch-module--container--9eebe";
export var description = "GlobalSearch-module--description--bc44d";
export var hidden = "GlobalSearch-module--hidden--8f0ab";
export var inactive = "GlobalSearch-module--inactive--36364";
export var input = "GlobalSearch-module--input--cd239";
export var inputFocusWithin = "GlobalSearch-module--inputFocusWithin--c19f7";
export var inputWrapper = "GlobalSearch-module--inputWrapper--c27ae";
export var label = "GlobalSearch-module--label--6667c";
export var link = "GlobalSearch-module--link--f89e2";
export var list = "GlobalSearch-module--list--6c566";
export var searchButton = "GlobalSearch-module--searchButton--78204";
export var searchButtonClose = "GlobalSearch-module--search-button--close--561d0";
export var tab = "GlobalSearch-module--tab--20d31";